import React, {useState} from 'react';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {Close, EditOutlined} from '@mui/icons-material';
import {theme} from '../Theme';
import BidmiiLinearProgress from '../modules/BidmiiCustomLoader/BidmiiLinearProgress';
import EditRequestForProposal from '../modules/ListViews/components/EditRequestForProposal';
import BidmiiTooltip from './StyledComponents/BidmiiTooltip';

interface IProps {
  title: string;
  handleClose?: any;
  current?: number | string;
  total?: number;
  projectLocked?: boolean;
  loading?: boolean;
  requestForProposal?: any;
  updateData?: () => void | undefined;
  type?: any;
}

export default function ToolbarHeader(props: IProps) {
  const [editProjectOpen, setEditProjectOpen] = useState(false);
  return (
    <>
      <Toolbar
        style={{
          backgroundColor: props.projectLocked
            ? '#242424'
            : theme.palette.secondary.main,
          minHeight: 56,
          paddingLeft: window.outerWidth > 600 ? 24 : 16,
        }}>
        {props.loading ? (
          <BidmiiLinearProgress />
        ) : (
          <div
            style={{height: 5, backgroundColor: theme.palette.secondary.main}}
          />
        )}
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography
            variant="subtitle1"
            alignItems="center"
            style={{
              color: props.projectLocked ? '#fff' : theme.palette.primary.light,
              lineHeight: 1.5,
              fontSize: 20,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '75%',
            }}>
            {props.title}
          </Typography>
          <Grid container alignItems="center" width="auto">
            {props.current && props.total && (
              <Typography variant="subtitle1" style={{lineHeight: 1.5}}>
                {props.current} / {props.total}
              </Typography>
            )}
            {props.type === 'my' && (
              <BidmiiTooltip title="Edit project details">
                <IconButton
                  style={{padding: '8px', marginTop: -2}}
                  color="primary"
                  aria-label="Edit project"
                  component="span"
                  onClick={() => setEditProjectOpen(true)}>
                  <EditOutlined style={{transform: 'scale(0.9)'}} />
                </IconButton>
              </BidmiiTooltip>
            )}
            {props.handleClose && (
              <IconButton
                onClick={props.handleClose}
                style={{marginLeft: 6, marginRight: -12}}
                size="large">
                <Close
                  fontSize="small"
                  color="primary"
                  style={{color: props.projectLocked ? '#fff' : 'initial'}}
                />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Toolbar>
      {editProjectOpen && props.updateData && (
        <EditRequestForProposal
          requestForProposal={props.requestForProposal}
          handleClose={() => setEditProjectOpen(false)}
          updateData={props.updateData}
        />
      )}
    </>
  );
}
